/* Publish by EComposer at 2026-10-02 09:57:02*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-x8mauomwe1"]=  window.__ectimmers["ecom-x8mauomwe1"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-x8mauomwe1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x8mauomwe1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-13wycyb6uy0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-13wycyb6uy0p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xmz4kcgddcs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xmz4kcgddcs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9r0uqg7wwb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9r0uqg7wwb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x7764zkchhi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x7764zkchhi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g1doo7wx28i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g1doo7wx28i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6swkthvg4ae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6swkthvg4ae', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oywy8nwpqw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oywy8nwpqw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vkcg78rkxzc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vkcg78rkxzc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tnxssu6i6r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tnxssu6i6r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eskifxey3p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eskifxey3p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xokdxm7k4zc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xokdxm7k4zc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-phzfjoqfmt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-phzfjoqfmt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f2ixz44dsvc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f2ixz44dsvc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jlz6cltldyc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jlz6cltldyc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zf3i9n7e7hp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zf3i9n7e7hp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9rxrjnskb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9rxrjnskb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dnd5annmeyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dnd5annmeyi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jz4i8rgsl1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jz4i8rgsl1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5htjbbdyrnn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5htjbbdyrnn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b3zzwnrv9u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b3zzwnrv9u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l15w74jqt7b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l15w74jqt7b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ibxehwy4sd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ibxehwy4sd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7i5e2o7am08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7i5e2o7am08', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jln59tgyre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jln59tgyre', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z76ods2rh1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z76ods2rh1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jb2xmyglybj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jb2xmyglybj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iyytvkuog7e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iyytvkuog7e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e2gvqato3v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e2gvqato3v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-by4d4cl58j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-by4d4cl58j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jsq7l2scvec').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jsq7l2scvec', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8emmos2ompo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8emmos2ompo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lncfwzflzuc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lncfwzflzuc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0e2enu8odxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0e2enu8odxl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-exsysdvo37').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-exsysdvo37', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dbekw429ltr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dbekw429ltr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ak8yftsycg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ak8yftsycg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bdm5sejfjn9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bdm5sejfjn9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cxvv2h1g76n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cxvv2h1g76n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hwj9gwusj3t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hwj9gwusj3t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rqfqz8bi1ca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rqfqz8bi1ca', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ooprc0a5fwq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ooprc0a5fwq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xruhkedgief').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xruhkedgief', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e2foysaoq27').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e2foysaoq27', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1brp717rd8v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1brp717rd8v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vxmom9ggrhc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vxmom9ggrhc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g7kjxt0opap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g7kjxt0opap', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dgkuli995i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dgkuli995i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9e5vdak2djh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9e5vdak2djh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w5kur7w2om').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w5kur7w2om', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ph5y5yelekq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ph5y5yelekq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8u3ikd49ado').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8u3ikd49ado', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0eni5xfgfyji').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0eni5xfgfyji', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wqb27g9un9n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wqb27g9un9n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-17zd4ria1qm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-17zd4ria1qm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3zz20ereg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3zz20ereg9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qrktom88dc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qrktom88dc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d6k8iq4onwh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d6k8iq4onwh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-447vq4ehumv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-447vq4ehumv', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-aqlrw48k30n"]=  window.__ectimmers["ecom-aqlrw48k30n"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-aqlrw48k30n"]["vv2lzacrt"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-aqlrw48k30n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aqlrw48k30n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ml77iwlacq8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ml77iwlacq8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fo1hrikqnsd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fo1hrikqnsd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-galwr60ygkl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-galwr60ygkl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8hj3as4929f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8hj3as4929f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1wq8zgrufho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1wq8zgrufho', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xm2v1zyef69').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xm2v1zyef69', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sixcd7var4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sixcd7var4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-esr6cog5tin').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-esr6cog5tin', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3qjvnw3o542').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3qjvnw3o542', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s7cmoslkrfc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s7cmoslkrfc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m5ka3r4delj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m5ka3r4delj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2yjvuf5mlma').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2yjvuf5mlma', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xzh9h67lagn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xzh9h67lagn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lcadbbq36rd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lcadbbq36rd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-31fq1lhby6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-31fq1lhby6a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qpc23k8pcq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qpc23k8pcq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zouore1up5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zouore1up5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8wi59saq2qi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8wi59saq2qi', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-y36cjl6xjg"]=  window.__ectimmers["ecom-y36cjl6xjg"] || {};
var E,$,A,I,j,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=(E=this.settings.disable_auto_close)!=null?E:!1,o=($=this.settings.disable_auto_close__tablet)!=null?$:!1,n=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,s=(I=this.settings.scroll_on_mobile)!=null?I:!1,r=(j=this.settings.disable_effect)!=null?j:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(L=>L.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function m(L){const O=L.getBoundingClientRect();return O.top>=0&&O.left>=0&&O.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&O.right<=(window.innerWidth||document.documentElement.clientWidth)}function g(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function f(L){return n&&L<768||o&&L>767&&L<1025||i&&L>1024}function b(L){if(!L)return;const O=L.style.transition;L.style.transition="none",L.style.height="auto";const B=L.scrollHeight;L.style.height="0px",L.offsetHeight,L.style.transition=O,requestAnimationFrame(()=>{const N=r?"auto":e?B+"px":"auto";L.style.height=N})}function y(L){L.classList.remove("ecom-item-active");const O=L.querySelector(":scope > .ecom-accordion__body");O&&(r||(O.style.height=O.scrollHeight+"px",O.offsetHeight),requestAnimationFrame(()=>{O.style.height="0px"}))}function v(L){let O=0;if(L.offsetParent)do O+=L.offsetTop;while(L=L.offsetParent);return O}function w(L){const O=Math.max(0,L),B=window.pageYOffset||document.documentElement.scrollTop,N=O-B;if(N===0)return;const Z=300;let X=null;function G(oe){X||(X=oe);const se=Math.min((oe-X)/Z,1),U=se<.5?2*se*se:1-Math.pow(-2*se+2,2)/2;window.scrollTo(0,B+N*U),se<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function k(L){w(v(L)-100)}function S(L,O=!1){L.forEach((B,N)=>{const Z=B.parentNode,X=Z.querySelector(":scope > .ecom-accordion__body");!r&&X&&X.classList.add("ecom-effect-accodion");const G=Z.classList.contains("ecom-item-active");X&&!a&&(O&&N===0||G)&&requestAnimationFrame(()=>{X.style.height=X.scrollHeight+"px"}),B.onclick=function(oe){var le,me;if(oe.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const se=g(),U=this.parentNode,de=U.parentNode,ge=de.querySelectorAll(":scope > .ecom-accordion__item"),ce=Array.from(ge).map(fe=>fe.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),ee=U.querySelector(":scope > .ecom-accordion__body");U.classList&&U.classList.remove("ecom-item-group-init");const q=this.classList.contains("ecom-item-active"),J=f(se);if(q)J?(this.classList.remove("ecom-item-active"),U.classList.remove("ecom-item-active"),y(U)):(ge.forEach(y),ce.forEach(fe=>fe.classList.remove("ecom-item-active")));else{J||(ge.forEach(y),ce.forEach(Te=>Te.classList.remove("ecom-item-active"))),B.classList.add("ecom-item-active"),U.classList.add("ecom-item-active");let fe=U.closest(".ecom-accordion__body");for(;fe;)fe.style.height="auto",fe=(me=(le=fe.parentElement)==null?void 0:le.closest)==null?void 0:me.call(le,".ecom-accordion__body");!r&&ee&&ee.classList.add("ecom-effect-accodion"),b(ee)}window.dispatchEvent(new window.Event("renderScroll"));const K=this,ue=s||se>1024;function Y(){window.dispatchEvent(new window.Event("renderScroll")),ue&&!m(K)&&k(K)}if(ue&&!r){let fe;const Te=function(Ce){Ce.propertyName==="height"&&(clearTimeout(fe),fe=setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},50))};de.addEventListener("transitionend",Te),setTimeout(()=>{de.removeEventListener("transitionend",Te),Y()},600)}else requestAnimationFrame(()=>{setTimeout(Y,100)})}})}S(d,!0),a||requestAnimationFrame(()=>{const L=t.querySelector(".ecom-item-group-init");L&&L.classList.remove("ecom-item-group-init")});function z(){const L=window.location.hash;if(L){const O=t.querySelector(`[data-target="${L}"]`);if(O){O.click(),O.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const Z=O.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(Z)}}}requestAnimationFrame(()=>{setTimeout(z,100)}),window.addEventListener("resize",()=>S(d)),window.addEventListener("hashchange",z,!1)

                    });
                    
                        document.querySelectorAll('.ecom-y36cjl6xjg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y36cjl6xjg', settings: {"disable_auto_close":true,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bvpqslfmno"]=  window.__ectimmers["ecom-bvpqslfmno"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-bvpqslfmno').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bvpqslfmno', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jeeillkdgj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jeeillkdgj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-te2ylugofpm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-te2ylugofpm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4om3erkh0an').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4om3erkh0an', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k66374fyh1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k66374fyh1', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1s2e0vz15ui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1s2e0vz15ui', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wtoz41tlefh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wtoz41tlefh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xvi27dtq9z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xvi27dtq9z', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vx50kwk34n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vx50kwk34n', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oner7yfkt3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oner7yfkt3c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5klzxwkud8f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5klzxwkud8f', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qdpps3awjtj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qdpps3awjtj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-35star68stl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-35star68stl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jiyw2m805ua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jiyw2m805ua', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3z3t0wgqav8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3z3t0wgqav8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nxqa2qlpngo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nxqa2qlpngo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ln2cjem1k0d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ln2cjem1k0d', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vy8vi56m2ks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vy8vi56m2ks', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ck99z08ns5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ck99z08ns5', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mn8hqsv4sh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mn8hqsv4sh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qw7fscsw3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qw7fscsw3l', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gg74wkllqsn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gg74wkllqsn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}